import React, { Suspense } from 'react';

/**
 * @component LazyLoad
 * @description Componente para carga lazy con fallback
 * Optimización: Reduce el bundle inicial y mejora LCP
 */

interface LazyLoadProps {
  children: React.ReactNode;
  fallback?: React.ReactNode;
  className?: string;
}

const DefaultFallback: React.FC = () => (
  <div className="flex items-center justify-center p-8">
    <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
  </div>
);

const LazyLoad: React.FC<LazyLoadProps> = ({ 
  children, 
  fallback = <DefaultFallback />,
  className 
}) => {
  return (
    <Suspense fallback={fallback}>
      <div className={className}>
        {children}
      </div>
    </Suspense>
  );
};

export default LazyLoad;
